import Tool from '../Tool';
import { makeWhiteboardToolHandler } from './helpers';

/**
 * Handler for WhiteboardAgent::WhiteboardEditTool
 * Processes whiteboard edit operations
 */
const whiteboardEditToolHandler = makeWhiteboardToolHandler(
  (toolCall, assistedWhiteboard) => {
    assistedWhiteboard.ensureVersionSaved();

    // Extract operation data from the tool call and pass to the whiteboard controller
    if (toolCall.content?.data) {
      const { operations } = JSON.parse(toolCall.content.data) as any;
      if (operations) {
        assistedWhiteboard.actionProcessOperations(operations, toolCall.id);
      }
    }
  }
);

Tool.register('WhiteboardAgent::WhiteboardEditTool', whiteboardEditToolHandler);
